import React, {
  Children,
  Dispatch,
  Fragment,
  useEffect,
  useRef,
  useState,
} from "react";
import { ReactNode } from "react";
import useWindowSize from "../../helpers/useWindowSize";
import {
  Badge,
  Button,
  Image,
  Menu,
  MenuPopover,
  MenuTrigger,
  Popover,
  PopoverSurface,
  PopoverTrigger,
  Radio,
  RadioGroup,
  Tooltip,
} from "@fluentui/react-components";
import {
  ChatBubblesQuestionFilled,
  ChatBubblesQuestionRegular,
  DismissFilled,
  DocumentPersonFilled,
  DocumentPersonRegular,
  EarthFilled,
  EarthRegular,
  HomeRegular,
  IosArrowRtl24Regular,
  MegaphoneFilled,
  MegaphoneRegular,
  PeopleTeamFilled,
  PeopleTeamRegular,
  PersonEditFilled,
  PersonEditRegular,
  PersonFilled,
  ShieldFilled,
  ShieldRegular,
  ShoppingBagAddFilled,
  ShoppingBagAddRegular,
  ShoppingBagFilled,
  ShoppingBagRegular,
  TextAlignJustifyFilled,
} from "@fluentui/react-icons";
import { useNavigate } from "react-router-dom";
import i18n from "i18next";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import authService from "../api-authorization/AuthorizeService";
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { baseUrl } from "../../helpers/constants";
import { IAppUserDto } from "../../Models/IAppUserDto";
import NavMenuEditUserDialog from "./NavMenu/NavMenuShowUser";
import NavMenu from "./NavMenu/NavMenu";
import { isTouchDevice } from "../../helpers/helperMethods";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { GlobalAppState } from "../../store/GlobalAppState";
import { ITeamRequest } from "../../Models/ITeamRequest";
import { IAppStateDto } from "../../Models/IAppStateDto";
import { setAppState } from "../../store/actionCreators";
interface IHeaderProps {
  HTMLElement?: ReactNode;
}
function Header(props: IHeaderProps) {
  /*Zum schauen ob Cookies akzeptiert sind*/
  const [cookieAccepted, setCookieAccepted] = useState(false);
  useEffect(() => {
    var accepted = localStorage.getItem("Luebbering_Digital_CookieAccepted");
    setCookieAccepted(accepted == null || accepted == "0" ? false : true);
  }, []);

  /*Für Benutzer und Roles*/
  const [benutzer, setBenutzer] = useState<IAppUserDto | undefined>();
  const [roles, setRoles] = useState([]);
  const getCurrentUser = () => {
    authService.getUser().then((user) => {
      if (user) {
        fetchWrapper
          .getWithAuth(`${baseUrl}/api/account/getcurrentuser`)
          .then((result: IAppUserDto) => {
            setBenutzer(result);
            // Bin eingeloggt, wir können die Rollen des Benutzers abfragen:
            fetchWrapper
              .getWithAuth(`${baseUrl}/api/account/getmyroles`)
              .then((result) => {
                setRoles(result);
              })
              .catch((error) => {});
          })
          .catch((error) => {});
      }
    });
  };
  const appState = useSelector(
    (state: GlobalAppState) => state.appState,
    shallowEqual
  );

  const dispatch: Dispatch<any> = useDispatch();

  const refreshAppState = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/account/GetAppState`)
      .then((data: IAppStateDto) => {
        dispatch(setAppState(data));
      });
  };

  useEffect(() => {
    refreshAppState();
  }, []);

  /* Für die Anzahl der Einladungen */
  const [myInvitesCount, setMyInvitesCount] = useState<number>(0);
  const getInvitesCount = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/teams/GetMyTeamRequests`)
      .then((result: ITeamRequest[]) => {
        setMyInvitesCount(result.length);
      });
  };

  /*Für die Buttons */
  const [hovered, setHovered] = useState<string | undefined>(undefined);
  const buttons = [
    {
      key: "termsofuse",
      iconRegular: <DocumentPersonRegular fontSize={24} />,
      iconFilled: <DocumentPersonFilled color="#ff6600" fontSize={24} />,
      text: i18n.t<string>("terms-of-use"),
      navigate: "/termsofuse",
    },
    {
      key: "privacypolicy",
      iconRegular: <ShieldRegular fontSize={24} />,
      iconFilled: <ShieldFilled color="#ff6600" fontSize={24} />,
      text: i18n.t<string>("privacy-policy"),
      navigate: "/privacypolicy",
    },
    {
      key: "imprint",
      iconRegular: <MegaphoneRegular fontSize={24} />,
      iconFilled: <MegaphoneFilled color="#ff6600" fontSize={24} />,
      text: i18n.t<string>("imprint"),
      navigate: "/imprint",
    },
    {
      key: "faq",
      iconRegular: <ChatBubblesQuestionRegular fontSize={24} />,
      iconFilled: <ChatBubblesQuestionFilled color="#ff6600" fontSize={24} />,
      text: "FAQ",
      navigate: "/faq",
    },
  ];

  /*Icons wenn es einen Benutzer gibt*/
  if (benutzer) {
    buttons.push(
      {
        key: "bedarfe",
        iconRegular: (
          <ShoppingBagRegular
            color={appState.bedarfeCount > 0 ? "#ff6600" : ""}
            fontSize={24}
          />
        ),
        iconFilled: <ShoppingBagFilled color="#ff6600" fontSize={24} />,
        text: i18n.t<string>("bedarfe"),
        navigate: "/account/requirements",
      },
      {
        key: "myteams",
        iconRegular: (
          <PeopleTeamRegular
            color={myInvitesCount > 0 ? "#ff6600" : ""}
            fontSize={24}
          />
        ),
        iconFilled: <PeopleTeamFilled color="#ff6600" fontSize={24} />,
        text: i18n.t<string>("my-teams"),
        navigate: "/account/myteams",
      },
      {
        key: "account",
        iconRegular: <PersonEditRegular fontSize={24} />,
        iconFilled: <PersonEditFilled color="#ff6600" fontSize={24} />,
        text: i18n.t<string>("manageAccount"),
        navigate: "/account",
      }
    );
  }
  /*Damit der ausgewählte Button gehovert ist */
  useEffect(() => {
    if (window.location.pathname && hovered == undefined) {
      setHovered(
        buttons.find((x) => window.location.pathname.includes(x.navigate))
          ?.navigate
      );
    }
  }, [window.location.pathname, hovered, benutzer]);

  /*
  Den momentanen Benutzer bekommen
  Der Eventlistener für Scroll
  */
  useEffect(() => {
    getCurrentUser();
    getInvitesCount();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  /* Für scroll Position */
  const [scrollPosition, setScrollPosition] = useState(0);
  const navigate = useNavigate();
  const handleScroll = () => {
    const position = window.scrollY;
    setScrollPosition(position);
  };

  /* Für die Breite der Header */
  const elementRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number | null>(null);
  const windowSize = useWindowSize();
  useEffect(() => {
    if (elementRef.current) {
      const style = window.getComputedStyle(elementRef.current);
      const tempWidth = parseFloat(style.width);
      setWidth(tempWidth);
    }
  }, [elementRef, windowSize]);
  const [isMenuOpen, setMenuOpen] = useState(false);

  /*Für die Sprache*/
  const [selectLanguageOpen, setSelectLanguageOpen] = useState<boolean>(false);
  const setLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    if (benutzer) {
      fetchWrapper
        .getWithAuth(`${baseUrl}/api/account/setlanguage?language=${lang}`)
        .then((result) => {
          console.log(result);
        });
    }
  };

  function NavOption() {
    return (
      <>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Popover open={selectLanguageOpen}>
            <PopoverTrigger>
              <Tooltip
                positioning="below"
                visible={hovered == "lang" && scrollPosition == 0}
                content={{
                  children: (
                    <>
                      {hovered === "lang" && scrollPosition == 0 && (
                        <>
                          <span
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              opacity: hovered === "lang" ? 1 : 0,
                              color: "#ff6600",
                              fontSize: "13px",
                              transition:
                                "opacity 0.1125s ease-in-out, margin-left 0.1125s ease-in-out",
                            }}
                          >
                            {i18n
                              .t<string>("sprache")
                              .split("")
                              .map((char, charIndex) => {
                                if (char != " ") {
                                  return (
                                    <span
                                      key={charIndex}
                                      style={{
                                        display: "inline-block",
                                        opacity: 0,
                                        transform: "translateX(-10px)",
                                        animation: `fadeInMove 0.135s ease forwards ${
                                          charIndex * 0.0225
                                        }s`,
                                      }}
                                    >
                                      {char}
                                    </span>
                                  );
                                } else return <div style={{ width: "5px" }} />;
                              })}
                          </span>
                          <style>
                            {` 
                                    @keyframes fadeInMove { 
                                      to { 
                                        opacity: 1; 
                                        transform: translateX(0); 
                                      } 
                                    } 
                                  `}
                          </style>
                        </>
                      )}
                    </>
                  ),
                  style: {
                    backgroundColor: "#faf9f8ad",
                    boxShadow:
                      scrollPosition > 0 ? "lightgrey 0px 0px 6px 3px" : " ",
                    backdropFilter: scrollPosition > 0 ? "blur(6px)" : " ",
                    filter: "unset",
                    padding: "0px",
                  },
                }}
                relationship={"label"}
              >
                <Button
                  size="large"
                  style={{
                    paddingLeft: "7px",
                    paddingRight: "7px",
                    minWidth: "40px",
                    minHeight: "40px",
                    height: "40px",
                    width: "40px",
                    display: "flex",
                    justifyContent: "flex-start",
                    transition: "width 0.1125s ease-in-out",
                    overflow: "hidden",
                  }}
                  onMouseEnter={() => {
                    if (isTouchDevice() == false) {
                      setHovered("lang");
                    }
                  }}
                  onMouseLeave={() => {
                    if (selectLanguageOpen == false) {
                      setHovered(undefined);
                    }
                  }}
                  appearance="transparent"
                  icon={
                    selectLanguageOpen == true ? (
                      <EarthFilled color="#ff6600" />
                    ) : (
                      <EarthRegular />
                    )
                  }
                  onClick={() => {
                    setSelectLanguageOpen(!selectLanguageOpen);
                  }}
                />
              </Tooltip>
            </PopoverTrigger>
            <PopoverSurface
              onMouseLeave={() => {
                setSelectLanguageOpen(false);

                setHovered(undefined);
              }}
            >
              <h4 style={{ fontWeight: 700 }}>
                {i18n.t<string>("spracheAuswaehlen")}
              </h4>
              <RadioGroup value={i18n.language.includes("de") ? "de" : "en"}>
                <Radio
                  onClick={() => {
                    if (i18n.language.includes("en")) {
                      setLanguage("de");
                      navigate(0);
                      setSelectLanguageOpen(false);
                    }
                  }}
                  value={"de"}
                  label={"Deutsch"}
                />
                <Radio
                  onClick={() => {
                    if (i18n.language.includes("de")) {
                      setLanguage("en");
                      navigate(0);
                      setSelectLanguageOpen(false);
                    }
                  }}
                  value={"en"}
                  label={"English"}
                />
              </RadioGroup>
            </PopoverSurface>
          </Popover>
          {buttons.map((btn, index) => (
            <Fragment key={index}>
              <Tooltip
                positioning="below"
                visible={hovered === btn.navigate && scrollPosition == 0}
                content={{
                  children: (
                    <>
                      {hovered === btn.navigate && scrollPosition == 0 && (
                        <>
                          <span
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              opacity: hovered === btn.navigate ? 1 : 0,
                              /* marginLeft:
                                      hovered === index ? "10px" : "0", */
                              color: "#ff6600",
                              fontSize: "13px",
                              transition:
                                "opacity 0.1125s ease-in-out, margin-left 0.1125s ease-in-out",
                            }}
                          >
                            {btn.text.split("").map((char, charIndex) => {
                              if (char != " ") {
                                return (
                                  <span
                                    key={charIndex}
                                    style={{
                                      display: "inline-block",
                                      opacity: 0,
                                      transform: "translateX(-10px)",
                                      animation: `fadeInMove 0.135s ease forwards ${
                                        charIndex * 0.0225
                                      }s`,
                                    }}
                                  >
                                    {char}
                                  </span>
                                );
                              } else return <div style={{ width: "5px" }} />;
                            })}
                          </span>
                          <style>
                            {` 
                                    @keyframes fadeInMove { 
                                      to { 
                                        opacity: 1; 
                                        transform: translateX(0); 
                                      } 
                                    } 
                                  `}
                          </style>
                        </>
                      )}
                    </>
                  ),
                  style: {
                    backgroundColor: "#faf9f8ad",
                    boxShadow:
                      scrollPosition > 0 ? "lightgrey 0px 0px 6px 3px" : " ",
                    backdropFilter: scrollPosition > 0 ? "blur(6px)" : " ",
                    filter: "unset",
                    padding: "0px",
                  },
                }}
                relationship={"label"}
              >
                <Button
                  size="large"
                  style={{
                    paddingLeft: "7px",
                    paddingRight: "7px",
                    minWidth: "fit-content",
                  }}
                  onMouseEnter={() => setHovered(btn.navigate)}
                  onMouseLeave={() => {
                    if (isTouchDevice() == false) {
                      setHovered(undefined);
                    }
                  }}
                  appearance="transparent"
                  icon={
                    window.location.pathname === btn.navigate
                      ? btn.iconFilled
                      : btn.iconRegular
                  }
                  onClick={() => {
                    navigate(btn.navigate);

                    setHovered(undefined);
                  }}
                >
                  {btn.key == "bedarfe" && appState.bedarfeCount > 0 && (
                    <Badge appearance="filled">{appState.bedarfeCount}</Badge>
                  )}
                  {btn.key == "myteams" && myInvitesCount > 0 && (
                    <Badge appearance="filled">{myInvitesCount}</Badge>
                  )}
                </Button>
              </Tooltip>
              {(btn.navigate === "/faq" || btn.navigate == "/account") && (
                <div
                  style={{
                    width: "1px",
                    backgroundColor: "#605e5c",
                    height: "35px",
                    marginLeft: "7px",
                    marginRight: "7px",
                  }}
                />
              )}
              {/* {btn.navigate === "/account" && (
                <div
                  style={{
                    width: "1px",
                    backgroundColor: "#605e5c",
                    height: "35px",
                    marginLeft: "7px",
                    marginRight: "14px",
                  }}
                />
              )} */}
            </Fragment>
          ))}
        </div>
        {benutzer != undefined && <NavMenuEditUserDialog user={benutzer} />}
        {benutzer == undefined && (
          <Button
            size="large"
            onClick={() => {
              navigate("/account/login");
            }}
            icon={<PersonFilled />}
            appearance="transparent"
            shape="square"
          >
            {i18n.t<string>("signIn")}
          </Button>
        )}
      </>
    );
  }
  if (windowSize.width > 1024) {
    return (
      <>
        {/*Das div-Element dient als Abstandshalter*/}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ marginTop: 14, marginBottom: 10 }}>
            <Image
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/");
              }}
              alt="LUEBBERING_DIGITAL_TRANSPARENT_NO_BORDER"
              src={`${baseUrl}/LUEBBERING_DIGITAL_TRANSPARENT_NO_BORDER.PNG`}
              height={32}
            />
          </div>
          <div style={{ display: "flex", padding: "3px" }}>
            {scrollPosition <= 0 && <NavOption />}
          </div>
        </div>
        <div
          ref={elementRef}
          style={{
            width: "100%",
            height: "70px",
          }}
        />
        {/*Inhalt der Header*/}
        <div
          style={{
            width: width ?? "auto",
            position: "fixed",
            backgroundColor: "#faf9f8ad",
            zIndex: "1000",
            top:
              scrollPosition > 10 ? "20px" : cookieAccepted ? "65px" : "90px",
            paddingLeft: "5px",
            padding: "3px",
            borderRadius: "2px",
            boxShadow: scrollPosition > 0 ? "lightgrey 0px 0px 6px 3px" : " ",
            backdropFilter: scrollPosition > 0 ? "blur(6px)" : " ",
            transition:
              "top 0.1s linear,box-shadow 0.40s ease-out, backdrop-filter 0.40s ease-out",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <StackShim horizontal verticalAlign="center">
              {benutzer != undefined && (
                <Menu
                  positioning={{ align: "center", position: "below" }}
                  open={isMenuOpen}
                >
                  <MenuTrigger disableButtonEnhancement>
                    <Tooltip
                      positioning="below"
                      visible={hovered == "menu" && scrollPosition == 0}
                      content={{
                        children: (
                          <>
                            {hovered === "menu" && scrollPosition == 0 && (
                              <>
                                <span
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    opacity: hovered === "menu" ? 1 : 0,
                                    color: "#ff6600",
                                    fontSize: "13px",
                                    transition:
                                      "opacity 0.1125s ease-in-out, margin-left 0.1125s ease-in-out",
                                  }}
                                >
                                  {"Menu".split("").map((char, charIndex) => {
                                    if (char != " ") {
                                      return (
                                        <span
                                          key={charIndex}
                                          style={{
                                            display: "inline-block",
                                            opacity: 0,
                                            transform: "translateX(-10px)",
                                            animation: `fadeInMove 0.135s ease forwards ${
                                              charIndex * 0.0225
                                            }s`,
                                          }}
                                        >
                                          {char}
                                        </span>
                                      );
                                    } else
                                      return <div style={{ width: "5px" }} />;
                                  })}
                                </span>
                                <style>
                                  {` 
                                    @keyframes fadeInMove { 
                                      to { 
                                        opacity: 1; 
                                        transform: translateX(0); 
                                      } 
                                    } 
                                  `}
                                </style>
                              </>
                            )}
                          </>
                        ),
                        style: {
                          backgroundColor: "#faf9f8ad",
                          boxShadow:
                            scrollPosition > 0
                              ? "lightgrey 0px 0px 6px 3px"
                              : " ",
                          backdropFilter:
                            scrollPosition > 0 ? "blur(6px)" : " ",
                          filter: "unset",
                          padding: "0px",
                        },
                      }}
                      relationship={"label"}
                    >
                      <Button
                        size="large"
                        onMouseEnter={() => {
                          if (isTouchDevice() == false) {
                            setHovered("menu");
                          }
                        }}
                        onMouseLeave={() => {
                          setHovered(undefined);
                        }}
                        onClick={() => {
                          setMenuOpen(!isMenuOpen);
                        }}
                        appearance={"transparent"}
                        icon={
                          isMenuOpen ? (
                            <DismissFilled />
                          ) : (
                            <TextAlignJustifyFilled />
                          )
                        }
                        style={{
                          paddingLeft: "0px",
                          paddingRight: "0px",
                          transition: "transform 0.3s ease-in-out",
                          transform: isMenuOpen
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                      />
                    </Tooltip>
                  </MenuTrigger>
                  <MenuPopover>
                    <div style={{ padding: "5px" }}>
                      <NavMenu
                        phoneView={false}
                        roles={roles}
                        user={benutzer}
                      />
                    </div>
                  </MenuPopover>
                </Menu>
              )}
              <Button
                onClick={() => {
                  navigate("/");
                }}
                icon={<HomeRegular fontSize={24} color="#ff6600" />}
                appearance="subtle"
                style={
                  benutzer == undefined
                    ? { minWidth: "85px", paddingLeft: "0px" }
                    : {}
                }
              >
                HOME
              </Button>
              {props.HTMLElement ? (
                <>
                  <IosArrowRtl24Regular
                    color="#ff6600"
                    /* style={{ marginRight: "16px" }} */
                  />
                  {props.HTMLElement}
                </>
              ) : (
                <div></div>
              )}
            </StackShim>
            <StackShim horizontal verticalAlign="center">
              {scrollPosition > 0 && <NavOption />}
            </StackShim>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <div style={{ marginTop: "15px", marginBottom: "15px", marginLeft: 5 }}>
        {props.HTMLElement}
      </div>
    );
  }
}
export default Header;
